<style lang="stylus">
.profile-incomplete-header {
  color: #333333;
  font-weight: 600 !important;
}

/* Override global v-card hover effects from LearnerProfileInfo.vue */
.profile-completion-card.v-card {
  border: none !important;
  cursor: default !important;
  transition: none !important;

  &:hover {
    border: none !important;
    box-shadow: none !important;
    cursor: default !important;
  }
}
</style>
<template>
  <v-col cols="12" sm="12" md="11" lg="8" xl="8" v-if="shouldShowCompletionBox()" class="px-0 py-0 no-col-padding">
    <v-card
      color="#FEC528"
      flat
      style="border-radius: 8px; cursor: default; box-shadow: none !important"
      class="mt-4 pl-0 elevation-0"
    >
      <v-row>
        <v-col cols="8" sm="8" md="8" lg="8" xl="8" class="py-6 px-6">
          <v-card-title
            class="headline profile-incomplete-header pt-4"
            :class="[$vuetify.display.xs ? 'pl-3' : 'pl-4']"
            :style="$vuetify.display.xs ? 'font-size: 18px !important' : ''"
          >
            Complete your profile</v-card-title
          >
          <v-card-text
            class="pt-0"
            :class="[$vuetify.display.xs ? 'pl-3' : 'pl-4']"
            style="font-size: 16px; font-weight: 400"
          >
            We are missing some demographic information about you. This type of information helps us in our work to
            improve the product experience for each of our learners.
          </v-card-text>
          <!-- TODO: @Rahul to add click event for modal -->
          <v-card-actions class="d-flex" :class="[$vuetify.display.xs ? 'pl-3' : 'pl-4']">
            <v-btn
              variant="flat"
              rounded
              class="px-6"
              style="background-color: #333333; color: white !important"
              @click="openModal()"
            >
              <span> Update Now </span>
            </v-btn>
          </v-card-actions>
        </v-col>
        <v-col
          cols="4"
          sm="4"
          md="4"
          lg="4"
          xl="4"
          style="text-align: center"
          :class="[{ 'align-self-start pt-3': $vuetify.display.xs, 'align-self-center': !$vuetify.display.xs }]"
        >
          <v-progress-circular
            id="profile-info-progress"
            :rotate="0"
            :size="$vuetify.display.xs ? 60 : 100"
            :width="6"
            :modelValue="profileCompletionProgress"
          >
            <div
              class="d-flex flex-column align-center justify-center text-center position-relative"
              style="z-index: 10"
            >
              <v-icon
                :class="[{ 'd-none': $vuetify.display.xs }]"
                size="large"
                color="#000000"
                class="font-weight-black"
                >mdi-account</v-icon
              >
              <div class="font-weight-black text-body-2">
                {{ profileCompletionProgress + '%' }}
              </div>
            </div>
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-card>
    <div v-show="false">{{ detectChange }}</div>
  </v-col>
</template>

<script>
import { defineComponent } from 'vue';

import { SessionInitializer } from '../mixins/sessionInitializer';

export default defineComponent({
  emits: ['openModal'],
  name: 'CompleteYourProfile',
  mixins: [SessionInitializer],

  data() {
    return {
      // TODO: Dynamically set it according to the modal data
      demographicInfo: {},
      basicLearnerInfo: {}
    };
  },

  props: {
    shouldRefreshData: Boolean
  },

  mounted() {
    // Profile Icon White Background
    if (document.querySelector('svg > circle.v-progress-circular__overlay'))
      document.querySelector('svg > circle.v-progress-circular__overlay').setAttribute('fill', 'white');
  },

  created() {
    this.demographicInfo = this.$conn.getDemographicInformation();
    this.basicLearnerInfo = this.$conn.getBasicLearnerInfo();
  },

  methods: {
    openModal() {
      this.$emit('openModal', true);
    },
    shouldShowCompletionBox() {
      if (this.profileCompletionProgress == 100) return false;

      //since pronoun is optional (making it complete if only pronoun is not selcted)
      if (this.profileCompletionProgress == 90 && !this.demographicInfo.pronoun) return false;

      return true;
    },
    getBasicAndDemograhicInfo() {
      // Refresh demographic and basic learner info when needed
      this.demographicInfo = this.$conn.getDemographicInformation();
      this.basicLearnerInfo = this.$conn.getBasicLearnerInfo();
    }
  },

  computed: {
    totalBasicLearnerInfo() {
      return Object.keys(this.basicLearnerInfo).length;
    },
    basicLearnerInfoEntered() {
      return Object.values(this.basicLearnerInfo).filter((e) => {
        return e;
      }).length;
    },
    totalDemographicInfo() {
      return Object.keys(this.demographicInfo).length;
    },
    demographicInfoEntered() {
      return Object.values(this.demographicInfo).filter((e) => {
        return e;
      }).length;
    },
    profileCompletionProgress() {
      return Math.round((this.demographicInfoEntered / this.totalDemographicInfo) * 100);
    },
    detectChange() {
      if (this.shouldRefreshData) {
        this.getBasicAndDemograhicInfo();
      }

      return this.shouldRefreshData;
    }
  }
});
</script>

<style lang="stylus" scoped>
#profile-info-progress {
  :deep(.v-progress-circular__underlay) {
  stroke: rgba(0, 0, 0, 0) !important;
}
}
</style>
